import { Form, InputNumber, Select } from 'antd';
import React from 'react';
import { USER_SOURCE_TO_NAME, UserSource } from 'src/types/teacher';

import { EditableContext, TableData } from './EditableTable';

const { Option } = Select;
interface Props {
  record: TableData;
  dataIndex: string;
  title: string;
  children: '';
  editable: boolean;
  restProps: '';
  editing: number;
}
interface State {
  editing: boolean;
  turns: number;
  isUpdate: boolean;
}

export class EditableCell extends React.Component<Props, State> {
  public form: any;
  public input: any;
  constructor(props: Props) {
    super(props);
    this.state = {
      editing: false,
      turns: -1,
      isUpdate: false,
    };
  }

  // toggleEdit = () => {
  //   const editing = !this.state.editing;
  //   this.setState({ editing }, () => {
  //     if (editing) {
  //       this.input.focus();
  //       this.setState({ turns: Number(this.input.props.value) });
  //     }
  //   });
  // };

  // save = e => {
  //   this.form.validateFields((error, values) => {
  //     if (error && error[e.currentTarget.id]) {
  //       return;
  //     }
  //     this.toggleEdit();
  //   });
  // };

  getMuTurns = value => {
    this.setState({ turns: value, isUpdate: true });
  };

  renderCell = form => {
    this.form = form;
    const { getFieldDecorator } = form;
    const { children, dataIndex, record, title, editing } = this.props;
    return editing ? (
      <Form.Item style={{ margin: 0 }}>
        {getFieldDecorator(dataIndex, {
          rules: [
            {
              required: true,
              message: `${title} is required.`,
            },
          ],
          initialValue: record[dataIndex],
        })(
          dataIndex === 'userSource' ? (
            <Select>
              <Option value={UserSource.NORMAL}>{USER_SOURCE_TO_NAME[UserSource.NORMAL]}</Option>
              <Option value={UserSource.SLM}>{USER_SOURCE_TO_NAME[UserSource.SLM]}</Option>
            </Select>
          ) : (
            <InputNumber />
          ),
        )}
      </Form.Item>
    ) : (
      children
    );
  };

  render() {
    const { editable, dataIndex, title, record, children, ...restProps } = this.props;
    return <td {...restProps}>{<EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>}</td>;
  }
}



// WEBPACK FOOTER //
// ./src/screens/group/EditableCell.tsx